import { render, staticRenderFns } from "./ms-open-door.vue?vue&type=template&id=1bff7160&scoped=true"
import script from "./ms-open-door.vue?vue&type=script&lang=js"
export * from "./ms-open-door.vue?vue&type=script&lang=js"
import style0 from "./ms-open-door.vue?vue&type=style&index=0&id=1bff7160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff7160",
  null
  
)

export default component.exports